import { handleExport } from "../utils/export.utils";

export const handleMenu = async (key, value, menus, ...rest) => {
  let tempMenus = [...menus];
  tempMenus.forEach((menu) => {
    menu.selected = false;
  });
  tempMenus[key].selected = value;
  if (tempMenus[key].txt === "Export") {
    await handleExport(...rest);
  }
  return tempMenus;
};

export const closeMenu = (menus, setMenus, setIsOpen) => {
  let tempMenus = [...menus];
  tempMenus.forEach((menu) => {
    menu.selected = false;
  });
  setIsOpen(false);
  setMenus(tempMenus);
};

